import { render, staticRenderFns } from "./createdNormalGoods.vue?vue&type=template&id=5285f969&scoped=true"
import script from "./createdNormalGoods.vue?vue&type=script&lang=js"
export * from "./createdNormalGoods.vue?vue&type=script&lang=js"
import style0 from "./createdNormalGoods.vue?vue&type=style&index=0&id=5285f969&prod&scoped=true&lang=css"
import style1 from "./createdNormalGoods.vue?vue&type=style&index=1&id=5285f969&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5285f969",
  null
  
)

export default component.exports